import React, {PureComponent, type Node} from 'react';
import {Link} from 'react-router-dom';
import {HEADER} from '@optimaxdev/analytics/mobile';

import type {VoidFunctionType, ActionCreatorType} from 'constants/flow/flowTypes';

import {Button} from 'components/__helpers/button/button';
import {sendAnalytics} from 'libs/analytics/sendAnalytics';

import s from './suggestions.scss';

type PropsType = {
    topSearches?: Array<{
        title: string,
        url: string,
    }>,
    closeQuickSearch: VoidFunctionType<>,
    onSelectSearchResult: ActionCreatorType<string>,
};

/**
 *  Class for searchBox
 */
export class Suggestions extends PureComponent<PropsType> {
    static defaultProps = {
        topSearches: [
            {title: 'RayBan', url: '/ray-ban'},
            {title: 'Prescription Glasses', url: '/eyeglasses-collection'},
            {title: 'Sunglasses', url: '/prescription-sunglasses'},
            {title: 'Blue Light', url: '/computer-glasses'},
            {title: 'Transitions', url: '/transitions-lenses '},
        ],
    };

    /**
     * Create handler for link with search result
     * @param {string} name - Name
     * @returns {VoidFunctionType} - On click handler
     */
    getHandlerClickOnLink = (name: string): VoidFunctionType<> => () => {
        const {onSelectSearchResult} = this.props;
        sendAnalytics(HEADER.BUTTON, {
            buttonName: 'Search',
            label: name,
        });
        onSelectSearchResult(name);
    };

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render(): Node {
        const {topSearches, closeQuickSearch} = this.props;

        return (
            <div className={s.container}>
                <h3 className={s.title}>Top Searches</h3>
                <div className={s.suggestions}>
                    {topSearches.map(item => (
                        <div
                            className={s.link}
                            key={item.title}
                            onClick={closeQuickSearch}
                            data-test-name="suggestion"
                            data-test-value={item.title}
                        >
                            <Link to={item.url} onClick={this.getHandlerClickOnLink(item.title)}>
                                <Button color="secondary" size="small">
                                    {item.title}
                                </Button>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
